import moment from 'moment';

const getRangeList = (startDate, endDate) => {
  let daysArray = [];
  let date = startDate;

  while (moment(date).isSameOrBefore(endDate, 'day')) {
    const day = moment(date).format('dddd');
    const number = moment(date).format('D');

    daysArray.push({
      day: day,
      number: number,
      date: date
    });
    date = moment(date).add(1, 'day');
  }

  return daysArray;
};

export { getRangeList };
